import { mergeEventTransformerHooks } from "@b2bportal/core-tracking";

import { FLIGHTS_PRICE_FREEZE_EXERCISE_EVENT_TRANSFORMER_HOOKS } from "./exerciseTransformers";
import { FLIGHTS_PRICE_FREEZE_PURCHASE_EVENT_TRANSFORMER_HOOKS } from "./purchaseTransformers";

export const CORE_FLIGHTS_PRICE_FREEZE_HTS_EVENT_TRANSFORMER_HOOKS =
  mergeEventTransformerHooks(
    FLIGHTS_PRICE_FREEZE_EXERCISE_EVENT_TRANSFORMER_HOOKS,
    FLIGHTS_PRICE_FREEZE_PURCHASE_EVENT_TRANSFORMER_HOOKS
  );
